import React, { FC, ReactNode } from 'react'
import { Box, Stack, Typography } from '@mui/material'

import { PORTAL_TEXT } from '@/apps/latest/shared/styles/portalTypography'

// table と body の間に inline strip. design/18 §2.3 R5.
// caption: 件数等 (12/muted), actions: 更新/CSV/sort 等.
interface TableToolbarProps {
  caption?: ReactNode
  actions?: ReactNode
}

export const TableToolbar: FC<TableToolbarProps> = ({ caption, actions }) => (
  <Stack
    direction="row"
    alignItems="center"
    justifyContent="space-between"
    gap={1}
    sx={{ py: 1 }}
  >
    {caption ? (
      <Typography sx={PORTAL_TEXT.caption}>{caption}</Typography>
    ) : (
      <Box />
    )}
    {actions && (
      <Stack direction="row" gap={1} alignItems="center">
        {actions}
      </Stack>
    )}
  </Stack>
)
